import { Check } from "lucide-react";
import React from "react";
import Spinner from "../../../Spinner";
import { BaseChipCheckboxBox } from "./styled";
import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable-next-line import/prefer-default-export */
export var COMPONENTS = {
  LOADING: /*#__PURE__*/_jsx(Spinner, {
    size: "xs"
  }),
  CHECKED: /*#__PURE__*/_jsx(Check, {
    size: "1rem",
    color: "var(--vitality-colors-success11)"
  }),
  UNCHECKED: /*#__PURE__*/_jsx(BaseChipCheckboxBox, {})
};